export default {
  install (Vue) {
    Vue.prototype.$snackbar = function (snackbar) {
      if (!snackbar) {
        // EX: this.$snackbar()
        this.$bus.$emit(this.$bus.CLEAR_SNACKBAR);
      } else {
        // EX: this.$snackbar({title: 'Your workflow is not saved.', btn: 'Save Now'})
        this.$bus.$emit(this.$bus.CREATE_SNACKBAR, snackbar);
      }
    }
  }
}
